'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Expand = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Expand, _Component);

  function Expand() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Expand);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Expand.__proto__ || (0, _getPrototypeOf2.default)(Expand)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: _this.props.show || false,
      titleLeft: _this.props.titleLeft || null,
      titleRight: _this.props.titleRight || null,
      noneRadius: _this.props.noneRadius || false,
      index: _this.props.index || null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Expand, [{
    key: 'toggle',

    // @Action
    value: function toggle() {
      this.setState({ show: !this.state.show });
    }
  }, {
    key: 'head',
    value: function head() {
      var styles = require('./Expand.scss');
      var _state = this.state,
          index = _state.index,
          show = _state.show,
          noneRadius = _state.noneRadius;
      var borderTopRadius = styles.borderTopRadius,
          borderBottomRadius = styles.borderBottomRadius,
          borderBottomRadiusNone = styles.borderBottomRadiusNone,
          borderBottom = styles.borderBottom;
      var head = styles.head;

      if (noneRadius) return head;
      switch (index) {
        case 'one':
          head = head + ' ' + borderTopRadius + ' ' + borderBottomRadius;
          break;
        case 'first':
          head = head + ' ' + borderTopRadius;
          break;
        case 'last':
          head = head + ' ' + borderBottomRadius;
          break;
        default:
          break;
      }
      if (show) head = head + ' ' + borderBottomRadiusNone + ' ' + borderBottom;
      return head;
    }
  }, {
    key: 'render',
    value: function render() {
      var show = this.state.show;
      var _props = this.props,
          titleLeft = _props.titleLeft,
          titleRight = _props.titleRight,
          contentClassName = _props.contentClassName;

      var styles = require('./Expand.scss');
      var head = this.head();
      return _react2.default.createElement(
        'div',
        { className: styles.expand },
        _react2.default.createElement(
          'div',
          { className: head, onClick: this.toggle.bind(this) },
          !!titleLeft && _react2.default.createElement(
            'div',
            { className: styles.title },
            ' ',
            titleLeft,
            ' '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            !!titleRight && _react2.default.createElement(
              'div',
              { className: styles.title },
              titleRight
            ),
            _react2.default.createElement(
              'div',
              { className: styles.btn },
              show ? _react2.default.createElement('i', { className: 'fa fa-angle-down' }) : _react2.default.createElement('i', { className: 'fa fa-angle-up' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: (show ? styles.content : styles.hide) + ' ' + contentClassName
          },
          this.props.children
        )
      );
    }
  }]);
  return Expand;
}(_react.Component), _class.propTypes = {
  number: _react.PropTypes.number,
  show: _react.PropTypes.bool,
  titleLeft: _react.PropTypes.string,
  titleRight: _react.PropTypes.string,
  noneRadius: _react.PropTypes.bool,
  children: _react.PropTypes.array.isRequired,
  index: _react.PropTypes.string,
  contentClassName: _react.PropTypes.string,
  border: _react.PropTypes.bool
}, _temp2);
exports.default = Expand;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Expand.js
// module id = 1557
// module chunks = 0